<template>
  <div class="sign-in-record">
    <AppNavBar :placeholder="true" title="打卡记录"></AppNavBar>
    <div class="record-list">
      <div class="record-item" v-for="(item, index) in recordList" :key="index">
        <img class="item-icon" :src="item.icon" alt="" />
        <div class="item-name">{{ item.name }}</div>
        <div class="item-time">{{ item.created_at }}</div>
      </div>
      <div class="empty" v-if="loaded && !recordList.length">
        <div>暂无数据</div>
      </div>
      <div class="not-more" v-if="loaded && recordList.length">
        <div>没有更多了</div>
      </div>
    </div>
    <AppLoading class="app-loading" v-if="!loaded" />
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
import AppNavBar from '@/components/app/nav-bar/index.vue'
export default {
  components: { AppNavBar, AppLoading },
  data() {
    return {
      loaded: false,
      recordList: []
    }
  },
  created() {
    this.getRecordList()
  },
  methods: {
    async getRecordList() {
      let res = await this.$http
        .getApp('api/v1/SignActivity/zeroClockRecord', {
          activity_id: this.$route.query.activityId
        })
        .catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.recordList = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.app-loading {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}
.record-list {
  padding: 0px 16px 100px;
  .record-item {
    padding: 8px 6px;
    display: flex;
    align-items: center;
    border-bottom: 0.5px solid rgba(220, 220, 220, 1);
    .item-icon {
      width: 44px;
      height: 44px;
      object-fit: contain;
      margin-right: 16px;
    }
    .item-name {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 10px;
    }
    .item-time {
      font-size: 11px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
.empty {
  margin-top: 100px;
  text-align: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
.not-more {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
</style>
